import { Injectable } from '@angular/core';
import { TSocialContent } from '@interfaces/campaign-analytics-api.interface';
import { SocialUtilitiesService } from '@utilities/social-utilities.service';
import { ICreatorDetailsFilter } from './creator-details.interface';

@Injectable({
  providedIn: 'root',
})
export class CreatorDetailsFilterService {
  public filterSocialContents(
    socialContents: TSocialContent[],
    creatorDetailsFilter: ICreatorDetailsFilter,
  ): TSocialContent[] {
    const filteredSocialContents: TSocialContent[] = [];

    for (const socialContent of socialContents) {
      if (
        creatorDetailsFilter.channelTechnicalIds.has(
          `${socialContent.channelId}_${SocialUtilitiesService.getPlatform(socialContent.platformFeature)}`,
        ) ||
        creatorDetailsFilter.channelTechnicalIds.size === 0
      ) {
        filteredSocialContents.push(socialContent);
      }
    }

    return filteredSocialContents;
  }
}
